(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bison-pro-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // Persist tab state across theme editor re-renders
    window.__bisonUpgradesState = window.__bisonUpgradesState || {};

    function getId(el) {
      return el.getAttribute('data-spot') || el.getAttribute('data-row');
    }

    function clearActive(scope) {
      scope.querySelectorAll('.bison-upgrades__row.is-active, .bison-hotspot.is-active')
        .forEach(function(el) { el.classList.remove('is-active'); });
      scope.querySelectorAll('[data-row-trigger][aria-expanded="true"]')
        .forEach(function(el) { el.setAttribute('aria-expanded', 'false'); });
    }

    function setActive(panel, id) {
      clearActive(panel);
      panel.querySelectorAll('[data-row="' + id + '"], [data-spot="' + id + '"]')
        .forEach(function(el) { el.classList.add('is-active'); });
      var trigger = panel.querySelector('[data-row-trigger="' + id + '"]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function initUpgrades(root) {
      var uid = root.getAttribute('data-upgrades');
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      var leaveTimer;

      function switchTab(target) {
        var targetStr = String(target);
        tabs.forEach(function(t) {
          var on = t.getAttribute('data-tab') === targetStr;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function(p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === targetStr);
        });
        clearActive(root);
        window.__bisonUpgradesState[uid] = targetStr;
      }

      // Restore previously active tab (for theme editor re-renders)
      var savedTab = window.__bisonUpgradesState[uid];
      if (savedTab) switchTab(savedTab);

      // Tab switching
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          switchTab(tab.getAttribute('data-tab'));
        });
      });

      // Per-panel sync wiring
      panels.forEach(function(panel) {
        var syncTargets = panel.querySelectorAll('.bison-hotspot, .bison-upgrades__row');

        if (canHover) {
          syncTargets.forEach(function(el) {
            el.addEventListener('mouseenter', function() {
              clearTimeout(leaveTimer);
              setActive(panel, getId(el));
            });
            el.addEventListener('mouseleave', function(e) {
              var next = e.relatedTarget && e.relatedTarget.closest
                ? e.relatedTarget.closest('.bison-hotspot, .bison-upgrades__row')
                : null;
              if (next && getId(next) === getId(el)) return;
              clearTimeout(leaveTimer);
              leaveTimer = setTimeout(function() { clearActive(panel); }, 120);
            });
          });
        } else {
          syncTargets.forEach(function(el) {
            el.addEventListener('click', function() {
              var id = getId(el);
              if (!id) return;
              var row = panel.querySelector('[data-row="' + id + '"]');
              if (row && row.classList.contains('is-active')) {
                clearActive(panel);
              } else {
                setActive(panel, id);
              }
            });
          });
        }
      });
    }

    function bindAll(scope) {
      (scope || document).querySelectorAll('[data-upgrades]').forEach(initUpgrades);
    }

    bindAll();

    // Theme editor: re-init after section re-render
    document.addEventListener('shopify:section:load', function(e) {
      bindAll(e.target);
    });

    // === Trust ribbon: auto-rotate on mobile ===
    function initTrustRibbon(root) {
      var mode = root.getAttribute('data-mobile-mode');
      if (mode !== 'rotate') return;

      var items = root.querySelectorAll('.bison-trust__item');
      if (items.length < 2) return;

      var interval = parseInt(root.getAttribute('data-rotate-interval'), 10) || 4000;
      var mq = window.matchMedia('(max-width: 749px)');
      var timer = null;
      var idx = 0;

      function show(i) {
        items.forEach(function(el, n) {
          el.classList.toggle('is-active', n === i);
        });
      }

      function start() {
        stop();
        show(0);
        idx = 0;
        timer = setInterval(function() {
          idx = (idx + 1) % items.length;
          show(idx);
        }, interval);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
        items.forEach(function(el) { el.classList.remove('is-active'); });
      }

      function sync() {
        if (mq.matches) start(); else stop();
      }

      sync();
      mq.addEventListener('change', sync);
    }

    function bindTrust(scope) {
      (scope || document).querySelectorAll('[data-trust]').forEach(initTrustRibbon);
    }

    bindTrust();

    document.addEventListener('shopify:section:load', function(e) {
      bindTrust(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
